import React from 'react';
import {
  SimpleDataTable as DataTable
} from '../../../web.common';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../../common/withRouter';
import withApi from '../../higherOrderComponents/withApi';
import {
  DisplayDate,
  DisplayGuid
} from '../../items';

const resultsCount = 15;

class FieldsInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
  }

  async loadData(skipPages) {
    const {
      props: {
        api: { purchases: { searchFields } },
        purchaseProductId
      }
    } = this;

    let result = null;

    try {
      result = await searchFields({
        filters: {
          purchaseProductId
        },
        skipPages,
        resultsCount
      }
      );
    }
    catch (e) {
      console.error(`unable to load. ${e}`);

      return;
    }

    return result;
  }

  render() {
    const {
      page
    } = this.state;
    const pageNumber = page || 1;

    const getData = async () => this.loadData(pageNumber || 1);

    return (
      <React.Fragment>
        <DataTable
          key={`purchase-fields-page-${page}`}
          style={{ marginTop: '100px' }}
          tableConfig={{
            tableName: 'products',
            columns: [
              {
                property: 'Id',
                label: 'Id',
                render: ({ Id }) => <DisplayGuid>{Id}</DisplayGuid>
              },
              {
                property: 'CreatedAtCet',
                label: 'Created At (CET)',
                render: ({ CreatedAtCet }) => <DisplayDate>{ CreatedAtCet }</DisplayDate>
              },
              {
                property: 'Key',
                label: 'Key'
              },
              {
                property: 'Value',
                label: 'Value'
              }
            ]
          }}
          getData={getData}
          paginationData={{
            renderLocation: 'bottom',
            rowsPerPage: resultsCount,
            pageNumber,
            goToPageNumber: number => {
              this.setState({
                page: number
              });
            }
          }}
          cellVerticalAlign='top'
          hideTableHead={false}
          languageCode='en'
          labels={{
            tableBody: {
              noResult: 'no results'
            }
          }}
          cellContent='cellContent'
        />
      </React.Fragment>
    );
  }
}

const Fields = withRouter(withApi(
  connect(({ user, categories }) => ({ isLoggedIn: !!user, categories }), {})(FieldsInternal)
));
Fields.requiresLogin = true;
Fields.propTypes = { isLoggedIn: PropTypes.bool };

export default Fields;
